module.exports = __webpack_public_path__ + "img/exterior_6.e496477a.jpg";